<template>
	<v-row class='fill-height' align="end">
		<v-col cols='3'>
			<v-img :src="require('@/assets/img/tripleplayLottery/coin_4.png')" width="150px" style="position: absolute; top: -40px;left: 0"></v-img>
			<v-row align="end" no-gutters class='fill-height'>
				<v-col cols='12' class='text-center'>
					<div id='current-time' class='white--text'>
						<font-awesome-icon icon='clock'></font-awesome-icon>
						<current-time-display :general-information='generalInformation'/>
					</div>
				</v-col>
				<v-col cols='12'>
					<card-presenter
						:time-per-page='[timeToShowPrizesPage, timeToShowResultsPage]'>
						<template #page-1>
							<v-card class='w-100 white--text prizes-card align-center d-flex h-100' rounded='xl'>
								<v-row no-gutters>
									<v-col cols='12'>
										<span class='prizes-title'>Prizes</span>
										<prizes-list class='font-weight-bold' :general-information='generalInformation'>
											<template #prize-row='{prize}'>
												<v-col class='prize-name' cols='6'>
													{{ prize.name }}
												</v-col>
												<v-col class='prize-amount' cols='6'>
													{{ prize.amount }}
												</v-col>
											</template>
										</prizes-list>
									</v-col>
								</v-row>
							</v-card>
						</template>
						<template #page-2>
							<v-card id='lottery-results' class='w-100 white--text align-center d-flex h-100 rounded-xl'>
								<lottery-result-auto-display
									:general-information='generalInformation'
									:entries-per-page='lotteryEntriesPerPage'
									:time-to-show-each-page='timeToShowEachLotteryResultPage'>
									<template #page='{ entries }'>
										<v-container class='px-0 py-0'>
											<lottery-result v-for='(entry, index) in entries'
												class='lottery-result'
												:class="{'rounded-b-xl': index === entries.length - 1}"
												:key='entry.name'
												:lottery='entry'>
												<template #sortition-header='{sortition, icon, date}'>
													<span class='sortition-header'>
														<font-awesome-icon :icon='icon'></font-awesome-icon>
														<span class="font-weight-bold">{{ sortition.name }}</span><br/> <span class="font-weight-bold">{{ date }}</span>
													</span>
												</template>
											</lottery-result>
										</v-container>
									</template>
								</lottery-result-auto-display>
							</v-card>
						</template>
					</card-presenter>
				</v-col>
			</v-row>
		</v-col>

		<v-col cols='5'>
			<v-row no-gutters>
				<v-col class='justify-center'>
					<v-img class='mx-auto' contain width='200' :src="require('@/assets/img/tripleplayLottery/logo.png')"/>
				</v-col>
			</v-row>
			<v-row justify="center" no-gutters>
				<v-col cols="8">
					<v-card class='white--text rounded-xl'>
						<countdown
							id="upcoming-result"
							class="text-center mt-5"
							:sortition="generalInformation.sortition">
							<template #default='{sortition}'>
								<v-flex md3>
									<h1 class='font-weight-bold text-uppercase'>Next draw in</h1>
								</v-flex>
								<v-flex md3>
									<span id='time-left' v-if='sortition.timeLeft'
										class='font-weight-black text-uppercase'>{{ sortition.timeLeft }}</span>
									<span v-else><font-awesome-icon icon='sync' spin size='3x'></font-awesome-icon></span>
								</v-flex>
								<v-flex md3>
									<h3 class="mb-2">{{ sortition.name }}</h3>
								</v-flex>
							</template>
						</countdown>
					</v-card>
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-col cols="10">
					<v-card id="last-winning-card" class='white--text text-center fill-height rounded-xl'>
						<div class='font-weight-bold my-1 text-uppercase text-center text-h5 white--text'>LAST WINNNING NUMBERS</div>
						<result-horizontal-display v-if='generalInformation.results[0]'
							:image-dimensions="{ height: '38px', width: '38px' }"
							:result='generalInformation.results[0]'
							:pick-two-image="{ src: require('@/assets/img/tripleplayLottery/pickTwo.webp'), width: '90px', height: '50px',contain: true }"
							:pick-three-image="{ src: require('@/assets/img/tripleplayLottery/pickThree.webp'), width: '90px', height: '50px',contain: true }"
							:pick-four-image="{ src: require('@/assets/img/tripleplayLottery/pickFour.webp'), width: '90px', height: '50px', contain: true }"
							:pick-five-image="{ src: require('@/assets/img/tripleplayLottery/pickFive.webp'), width: '80px', height: '50px', contain: true }"
							>
							<template #name="{sortition}">
								<h4 class="font-weight-bold text-uppercase text-wrap">{{ sortition.name }}</h4>
							</template>
						</result-horizontal-display>
					</v-card>
				</v-col>
			</v-row>
		</v-col>

		<v-col cols='4'>
			<v-row no-gutters>
				<v-col cols='12'>
					<v-row justify='center' no-gutters>
						<v-col cols='auto'>
							<h1 class='white--text'>DRAWING HOURS</h1>
						</v-col>
					</v-row>
					<v-row justify='center' no-gutters>
						<v-col v-for='sortition in generalInformation.sortedSortitions' cols='auto' :key='sortition.id'>
							<span
								class="font-weight-bold text-h5 mx-2"
								:class='{"next-drawing--text": generalInformation.sortition.id === sortition.id, "white--text": generalInformation.sortition.id !== sortition.id }'>
								{{ sortition.abbreviation }}
							</span>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols='12' class="py-2" v-for='(result) in generalInformation.results.slice(1, 3)' :key='result.sortition.id'>
					<v-card class='white--text text-center fill-height rounded-xl'>
						<result-horizontal-display
							:result='result'
							:pick-two-image="{ src: require('@/assets/img/tripleplayLottery/pickTwo.webp'), width: '80px', height: '50px',contain: true }"
							:pick-three-image="{ src: require('@/assets/img/tripleplayLottery/pickThree.webp'), width: '80px', height: '50px',contain: true }"
							:pick-four-image="{ src: require('@/assets/img/tripleplayLottery/pickFour.webp'), width: '80px', height: '50px', contain: true }"
							:pick-five-image="{ src: require('@/assets/img/tripleplayLottery/pickFive.webp'), width: '80px', height: '50px', contain: true }"
							>
							<template #name="{sortition}">
								<h4 class="font-weight-bold text-uppercase text-wrap">{{ sortition.name }}</h4>
							</template>
						</result-horizontal-display>
					</v-card>
				</v-col>
			</v-row>
		</v-col>

	</v-row>
</template>

<script>
import Countdown from '@homepage/components/Countdown.vue';
import {generateImageMapFor} from '@homepage/helpers/image.js';
import PrizesList from '@homepage/components/PrizesList.vue';
import CurrentTimeDisplay from '@homepage/components/CurrentTimeDisplay.vue';
import ResultHorizontalDisplay from "@homepage/components/ResultHorizontalDisplay.vue";
import CardPresenter from '@homepage/components/CardPresenter.vue';
import LotteryResultAutoDisplay from '@homepage/components/LotteryResultAutoDisplay.vue';
import LotteryResult from '@homepage/components/LotteryResult.vue';

export default {
	name: 'TriplePlayLotteryBoard',
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
			generalInformation: this.generalInformation
		};
	},
	props: {
		generalInformation: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			timeToShowPrizesPage: 8000,
			timeToShowEachLotteryResultPage: 40000,
			lotteryEntriesPerPage: 2
		};
	},
	components: {
		CurrentTimeDisplay,
		ResultHorizontalDisplay,
		PrizesList,
		Countdown,
		CardPresenter,
		LotteryResult,
		LotteryResultAutoDisplay,
	},
	computed: {
		timeToShowResultsPage() {
			const timeToShowEachPage = this.timeToShowEachLotteryResultPage / 1000;

			return Math.ceil(this.generalInformation.lotteriesResultsEntries.length / this.lotteryEntriesPerPage) * timeToShowEachPage * 1000;
		}
	},
	beforeCreate() {
		this.$emit('change-style', {backgroundImage: require('@/assets/img/tripleplayLottery/background_2.webp')});
	}
};
</script>
<style scoped>

.theme--light.v-card {
border: 4px solid #f2bc00a1;
background-color: #7300007a;
backdrop-filter: blur(5px);
}

.prizes-title {
font-size: 300%;
font-weight: bold;
}

.prize-name {
font-size: 180%;
}

.prize-amount {
font-size: 200%;
font-weight: 800;
}

.prizes-card {
text-align: center;
}

#current-time {
font-size: 250%;
font-weight: bold;
}

::v-deep .prize-item:nth-child(odd) {
background-color: #5563a54f;
}

#time-left {
font-weight: bold;
font-size: 3.5rem;
text-align: center;
color: white;
}

@keyframes blink-border {
from {
border: 3px solid #7300007a;
box-shadow: 0 0 25px black;
}
to {
border: 3px solid #f2bc00a1;
box-shadow: 0 0 25px #818181;
}
}

.next-drawing--text {
color: #f2bc00a1;
}

#last-winning-card {
transition: border, box-shadow;
animation: blink-border 400ms infinite alternate ease;
}
</style>
